<template>
  <div class="criterio-select-lojas">
    <v-row>
      <v-col class="py-0" align="center">
        <select-campaigns
          :selected.sync="campaigns"
          :loading="loadingInitialState"
          :status="['ACTIVE', 'FINISHED']"
          :mode="['SMS', 'EMAIL', 'WHATSAPP', 'PUSH']"
          :disable-save="disableSave"
          :tooltip-primary-button="tooltipPrimaryButton"
          :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
          :disabled="disabled"
          :only-maria-campaign="componentParams.onlyMaria"
          :include-maria-campaign="componentParams.includeMaria || componentParams.onlyMaria"
          single-line
          hide-details
        />
      </v-col>
    </v-row>
    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(campaign, index) in campaigns"
        :key="`${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeSelectedCampaign(index)"
      >
        <span>{{ truncate(campaign.title) }}</span>
      </v-chip>
    </v-chip-group>

    <v-chip-group v-if="loadingInitialState" column active-class="primary--text">
      <v-chip v-for="(campaign, index) in initialValue" :key="`${index}-loading`" class="disabled-chip" small :ripple="false">
        <v-progress-circular indeterminate color="primary" size="15" />
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import truncate from 'lodash/truncate'
import cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'vuex'
import SelectCampaigns from '@/components/select-campaigns/SelectCampaigns.vue'
import { QUERY_GET_GENERIC_CAMPAIGNS_BY_ID } from '@/modules/campanhas/views/components/graphql'

export default {
  components: {
    SelectCampaigns,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    campaigns: [],
    loadingInitialState: false,
  }),

  computed: {
    ...mapState({}),
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  watch: {
    campaigns(campaigns) {
      this.$emit('input', { currentValue: campaigns.map(({ _id }) => _id), currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
    },
  },

  async mounted() {
    if (this.initialValue && this.initialValue.length) {
      await this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    truncate(value) {
      return truncate(value, { length: 40, separator: ' ' })
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.campaigns && this.campaigns.length)
    },

    async setInitialState(campaignIds) {
      try {
        this.loadingInitialState = true
        const {
          data: {
            genericCampaigns: { campaigns },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_GENERIC_CAMPAIGNS_BY_ID,
          fetchPolicy: 'network-only',
          variables: {
            campaignIds,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        this.campaigns = campaigns
      } catch {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }

      this.loadingInitialState = false
    },

    removeSelectedCampaign(index) {
      const campaigns = cloneDeep(this.campaigns)
      campaigns.splice(index, 1)
      this.campaigns = campaigns
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
